import useTranslation from "next-translate/useTranslation";
import { setLeaguePlay, useLobby } from "../../redux/lobby";
import MembershipInfo from "./MembershipInfo";

export default function LobbyHead() {
  const { leaguePlay } = useLobby();
  const { t } = useTranslation("common");
  const { t: lobbyT } = useTranslation("lobby");

  return (
    <div className="mb-3 hidden w-full flex-wrap items-center justify-center gap-x-6 gap-y-3 md:mb-5 md:flex md:justify-between">
      <div className="hidden w-[260px] shrink-0 rounded-lg bg-gray-200 p-1 md:flex">
        {[
          { label: lobbyT("League"), league: true },
          { label: t("Practice"), league: false },
        ].map(({ label, league }) => (
          <button
            key={label}
            type="button"
            aria-pressed={leaguePlay === league}
            onClick={() => {
              if (leaguePlay !== league) setLeaguePlay(league);
            }}
            className={`min-h-[36px] flex-1 rounded-md px-4 py-2 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary ${
              leaguePlay === league
                ? "bg-white text-gray-800 shadow-sm"
                : "text-gray-600 hover:bg-white/50"
            }`}
          >
            {label}
          </button>
        ))}
      </div>
      <MembershipInfo />
    </div>
  );
}
